
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/offre/[slug]",
      function () {
        return require("private-next-pages/offre/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/offre/[slug]"])
      });
    }
  